export const API_HOST = import.meta.env.VITE_API_HOST as string;
export const API_EMAIL_VALIDATION_HOST = import.meta.env
  .VITE_API_EMAIL_VALIDATION_HOST as string;
export const API_MB_PLATFORM_HOST = import.meta.env
  .VITE_API_MB_PLATFORM_HOST as string;
export const ZIP_CODES_HOST = import.meta.env.VITE_ZIP_CODES_HOST as string;
export const UI_DASHBOARD_EXPRESS = import.meta.env
  .VITE_UI_DASHBOARD_EXPRESS as string;
export const ENV = import.meta.env.VITE_ENV as string;
